import {IImage} from './common.types';

export enum ContentTierInteractionType {
    BUTTON = 'Button',
    RADIO = 'Radio'
}

export enum ContentTierBadgeColor {
    RED = 'Red',
    GOLD = 'Gold'
}

export type TBillingPeriod = 'Monthly' | 'Annual' | 'Instalments';

export interface IContentTier {
    title: string;
    description: string;
    isCardHighlighted: boolean;
    showBestValueBadge: boolean;
    bestValueBadgeText: string;
    bestValueBadgeTextInstallment: string;
    bestValueBadgeTextAnnual: string;
    bestValueBadgeTextMonthly: string;
    showEyebrow: boolean;
    eyebrowText: string;
    entitlementSetId: string;
    compareEntitlementSetId: string;
    billingPeriod: string;
    compareBillingPeriod: string;
    showPrice: boolean;
    price: string;
    yearlyprice: string;
    monthlyprice: string;
    freeTrialText: string;
    showBadge: boolean;
    badgeText: string;
    badgeColor: ContentTierBadgeColor;
    showImage: boolean;
    image: IImage;
    interactionType: ContentTierInteractionType;
    button: any;
    showDivider: boolean;
    dividerText: string;
    showLogos: boolean;
    showOverrideLogos: boolean;
    overrideLogos: Array<string>;
    showBenefits: boolean;
    benefits: Array<IContentTierBenefit>;
    monthText: string;
    weekText: string;
    installmentText: string;
    yearText: string;
    overrideBadgeText: string;
    annualDescription: string;
    monthlyDescription: string;
    offerAnnualDescription: string;
    offerMonthlyDescription: string;
    showPlanUI: boolean;
}

export interface IContentTierBenefit {
    iconName: string;
    value: string;
    iconUrl: string;
    disabled: boolean;
}
export interface IContentTierBillingPlans {
    billingPeriodType: string;
    badgeText?: string;
    label: string;
    showBadge: boolean;
}

export interface IContentTiers {
    showWeeklyTierTop: boolean;
    preselectBillingPeriod: boolean;
    title: string;
    freeTrialTitle?: string;
    freeTrialDescription?: string;
    freeTrialMobileDescription?: string;
    description?: string;
    showBenefits?: boolean;
    showSeeMorePlans?: boolean;
    seeMorePlansText?: string;
    closeSeeMoreText?: string;
    benefits?: Array<IContentTierBenefit>;
    backgroundImage: IImage;
    showBillingPeriodSwitcher: boolean;
    defaultBillingPlan: TBillingPeriod;
    bestValueBadgeShown: boolean;
    showMoreDescriptionLabel: string;
    tiers: Array<IContentTier>;
    billingPlans: Array<IContentTierBillingPlans>;
    componentType: string;
    showPlanUI?: boolean;
    showWeeklyTierAside?: boolean;
    version?: string;
    entitlementSetId?: string;
    bottomDividerText?: string;
}

export class CardHeaderDetails {
    showBadge: boolean = false;
    badgeText: string = '';
    showDiscount: boolean = false;
    discountPercentage: number = 0;
    discountAmount: number = 0;
    showPrice: boolean = false;
    priceFrom: string = '';
    price: string = '';
    priceLabel: string = '';
    hasFreeTrial: boolean = false;
    freeTrialText: string = '';
}
